<template>
  <span class="text-no-wrap">
    <v-switch
      v-if="withIcon"
      :input-value="value"
      @click="onClick"
      :class="iconStyles"
      :readonly="readonly"
      :color="color"
      :disabled="disabled"
      true-value="active"
      false-value="inactive"
    />
    <span v-text="text" />
  </span>
</template>

<script>
import { css } from 'emotion'

export default {
  name: 'AppStatus',
  props: {
    value: {
      type: String,
      required: true,
    },
    withIcon: Boolean,
    readonly: {
      type: Boolean,
      default: false,
    },
    showText: {
      type: Boolean,
      default: true,
    },
    // info, successを渡せる
    color: {
      type: String,
      default: 'info',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    text() {
      if (!this.showText) {
        return null
      }
      switch (this.value) {
        case 'active': {
          return '有効'
        }
        case 'inactive': {
          return '無効'
        }
        default: {
          throw this.value
        }
      }
    },
    // disabledによって分岐する
    iconStyles() {
      if (this.readonly) {
        return css`
          display: inline-block !important;
          opacity: 0.3;
          pointer-events: none;
          .v-input__slot {
            margin: 0 !important;
          }
        `
      } else {
        return css`
          display: inline-block !important;

          .v-input__slot {
            margin: 0 !important;
          }
        `
      }
    },
    isActive() {
      return this.value === 'active'
    },
  },
  methods: {
    onClick(e) {
      e.stopPropagation()
      this.$emit('click', this.isActive)
    },
  },
}
</script>

<style></style>
